import * as React from 'react';
import { CommonQuestionListContainer } from '../../containers/questions/CommonQuestionListContainer';
import { ISurveyQuestionEditModel } from '../../models';

export interface IQuestionModalContentProps {
	isDemographic: boolean;
	isLoading: boolean;
	parentQuestion?: ISurveyQuestionEditModel;
	selectedCustomQuestionIds: number[];
	selectedQuestionVariationIds: number[];
	surveyId?: number;
}

export class QuestionModalContent extends React.PureComponent<IQuestionModalContentProps> {
	constructor(props: any) {
		super(props);
	}

	public render() {
		return <CommonQuestionListContainer {...this.props} />;
	}
}
